import React from 'react';
import type { PlaybookLifecycle, PlaybookSource } from '../types/playbook.types';

interface PlaybookFilterBarProps {
  practiceArea: string;
  lifecycle: string;
  source: string;
  onPracticeAreaChange: (v: string) => void;
  onLifecycleChange: (v: string) => void;
  onSourceChange: (v: string) => void;
}

const LIFECYCLE_OPTIONS: Array<{ value: PlaybookLifecycle | ''; label: string }> = [
  { value: '', label: 'All Lifecycles' },
  { value: 'draft', label: 'Draft' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'superseded', label: 'Superseded' },
  { value: 'archived', label: 'Archived' },
];

const SOURCE_OPTIONS: Array<{ value: PlaybookSource | ''; label: string }> = [
  { value: '', label: 'All Sources' },
  { value: 'manual', label: 'Manual' },
  { value: 'ai_generated', label: 'AI Generated' },
  { value: 'court_rules', label: 'Court Rules' },
  { value: 'imported', label: 'Imported' },
];

const selectClass =
  'rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm focus:border-lex-accent focus:outline-none focus:ring-1 focus:ring-lex-accent dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300';

const PlaybookFilterBar: React.FC<PlaybookFilterBarProps> = ({
  practiceArea, lifecycle, source,
  onPracticeAreaChange, onLifecycleChange, onSourceChange,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        type="text"
        value={practiceArea}
        onChange={(e) => onPracticeAreaChange(e.target.value)}
        placeholder="Practice area..."
        className={`${selectClass} w-40`}
      />
      <select value={lifecycle} onChange={(e) => onLifecycleChange(e.target.value)} className={selectClass}>
        {LIFECYCLE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <select value={source} onChange={(e) => onSourceChange(e.target.value)} className={selectClass}>
        {SOURCE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
};

export default PlaybookFilterBar;
